import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Mic } from "lucide-react";
import { toast } from "sonner";
import api from "@/lib/api";

/** Marketplace → Studio: shown for free beats, your own beats and beats you've licensed. */
export default function RecordInStudioButton({ beat, currentUser, compact = false }) {
  const navigate = useNavigate();
  const [busy, setBusy] = useState(false);
  const [licensed, setLicensed] = useState(false);
  const free = beat?.download_mode === "free" || beat?.license_type === "Free";
  const own = currentUser?.user_id && currentUser.user_id === beat?.user_id;

  useEffect(() => {
    if (compact || !currentUser?.user_id || free || own || !beat?.beat_id) return;
    api.get("/beats/me/purchases")
      .then((r) => setLicensed((r.data.purchases || []).some((p) => p.beat_id === beat.beat_id)))
      .catch(() => {});
  }, [currentUser?.user_id, beat?.beat_id, free, own, compact]);

  if (!beat?.audio_url || !(free || own || licensed)) return null;

  const go = async () => {
    if (!currentUser) { toast.error("Sign in to record in RGM Studio"); navigate("/login"); return; }
    setBusy(true);
    try {
      const r = await api.post("/studio/projects/from-beat", { beat_id: beat.beat_id });
      navigate(`/studio/session/${r.data.project.project_id}`);
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Could not open this beat in Studio");
    } finally { setBusy(false); }
  };

  return (
    <button type="button" onClick={go} disabled={busy}
      className={`${compact ? "h-8 px-2.5 text-xs" : "px-3 py-2 text-sm"} rounded-md bg-fuchsia-600 hover:bg-fuchsia-500 text-white font-bold inline-flex items-center gap-1.5 disabled:opacity-50 active:scale-95 transition-transform`}
      data-testid={compact ? `beat-card-record-${beat.beat_id}` : "beat-record-in-studio"}>
      <Mic className="w-4 h-4" />{busy ? "Opening…" : compact ? "Studio" : "Record in Studio"}
    </button>
  );
}
